import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from "react-router-dom";
import SecureLS from "secure-ls";
import DashBoardLayout from './components/DashBoardLayout';
import DailyReport from './components/Reports/DailyReports/DailyReport';
import Login from './components/Login/login';
import WeeklyReport from './components/Reports/RegulatoryReports/WeeklyReport';
import Otp from './components/OTP/Otp';
import Profile from './components/Profile/Profile';
import ReportBuilderMainLayout from './components/ReportBuilder';
import QuickSightAnalytics from './components/QuickSightAnalytics';
import Redirect from './components/Redirect/Redirect'

const Router = () => {
  var ls = new SecureLS();

  let isUserLoggedIn = ls.get("isUserLoggedIn");
  const navigate = useNavigate();


  useEffect(() => {
    if (!isUserLoggedIn) {
      console.log("going for navigation")
      navigate('/');
    } else {
      navigate("/app/analytics");
    }
  }, [isUserLoggedIn]);
  return (
    <Routes>
      {isUserLoggedIn ?(
         <Route path="/app" element={<DashBoardLayout />} >
         <Route path='/app/profile' element={<Profile />}/>
         <Route path='/app/analytics' element={<QuickSightAnalytics/>}/>
         <Route path='/app/daily' element={<DailyReport />} />
         <Route path='/app/weekly' element={<WeeklyReport />} />
         <Route path='/app/reportBuilder' element={<ReportBuilderMainLayout/>}  />
         </Route>
      ):( <Route path="/" element={<Login />}/>)
      }
      <Route path='/redirect' element={<Redirect/>}/>
    </Routes>
  )
}


export default Router